import { render, staticRenderFns } from "./UserManagementForm.vue?vue&type=template&id=25030e25"
import script from "./UserManagementForm.vue?vue&type=script&lang=js"
export * from "./UserManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports